import { config } from './config'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const hostname = window && window.location && window.location.hostname;

if (hostname === 'finramos.com') {
    firebase.initializeApp(config.prod)
  } else {
    firebase.initializeApp(config.stage)
  }
  
  const firestore = firebase.firestore()
  const settings = {timestampsInSnapshots: true};
  firestore.settings(settings);
  export const db = firestore
  export const firebaseAuth = firebase.auth
  


// WEBPACK FOOTER //
// ./src/firebase/index.js